<div class="player-stats" [ngStyle]="drawerStyles | theme">
    <app-nav-button icon="close" (clickEvent)="onCloseClick()"
      [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
      [size]="drawerConfig.closeButtonSize" [ngClass]="drawerConfig.closeButtonPosition" />
    
    <div class="profile-drawer">
        <div class="profile-header">
            <div [ngStyle]="nameStyles | theme">
                {{ nickName }}
            </div>
            <div class="icon-top-percentage">
                <app-icon [icon]="iconForGlobalRank" [colorCss]="colorForGlobalRank" sizeCss="--icon-medium"
                    *ngIf="unlockedGlobalRank" />
                <div [ngStyle]="rankStyles | theme">{{ subtitle }}</div>
            </div>
            <div class="pills">
                <div *ngFor="let pill of pills" >
                    <div class="pill" [ngStyle]="pillStyles | theme">
                        {{ pill.label }}
                    </div>
                </div>
            </div>
        </div>
        <div class="game-stats-list">
            <div class="stats-cell" *ngIf="statsList.length > 0" [ngStyle]="statCardStyles | theme">
                <div *ngFor="let stat of statsList" class="game-stats">
                    <img *ngIf="stat.medalSource" [src]="stat.medalSource" class="medal" alt="medal" />  
                    <app-icon *ngIf="!stat.medalSource" [icon]="stat.icon" [colorCss]="stat.colorCss" sizeCss="--icon-medium"></app-icon>
                    <div class="stat-score-content" [ngStyle]="statNameStyles | theme">
                        {{ stat.label }}
                    </div>
                    <div class="score-container">
                        <div class="amount">
                            <span class="stat-score" [ngStyle]="statAmountStyles | theme">{{ stat.score }}</span>
                            <app-currency-icon *ngIf="stat.currencyIcon" [icon]="stat.currencyIcon" sizeCss="--icon-medium"></app-currency-icon>
                        </div>
                        <div class="top-percentage" [ngStyle]="statRankStyles | theme">
                            {{ stat.percentage }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
